module.exports = __webpack_public_path__ + "img/abril_azul_-_autismo.d6ef2bd3.svg";